import { Component, Input } from '@angular/core';
import { Product2, WorkflowStateType, ProductWorkflowHistory } from 'situview-webapi-client';
import { AuthService, BreadcrumbService, StateService, ProductService, Utils } from 'src/app/services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SituBaseComponent } from 'src/app/shared/situ-base-component';
import { INewProduct } from 'src/app/views';

@Component({
  selector: 'product-workflow-history-tab',
  templateUrl: './product-workflow-history-tab.component.html',
  styleUrls: ['./product-workflow-history-tab.component.scss']
})

export class ProductWorkflowHistoryTabComponent extends SituBaseComponent {
  @Input() product: INewProduct = new Product2();

  workflowStateType = WorkflowStateType;

  workflowHistory?: ProductWorkflowHistory[];

  private _loading = 0;
  public get loading(): number { return this._loading; }

  public set loading(val: number) {
    this._loading = val;
    this.breadcrumbService.setIsLoading(val != 0);
  }

  constructor(
    authService: AuthService,
    stateService: StateService,
    private snackBar: MatSnackBar,
    private breadcrumbService: BreadcrumbService,
    private productService: ProductService) {
    super(authService, stateService);

  }

  ngOnInit(): void {
    super.ngOnInit();

    this.getWorkflowHistory();
  }
  
  getWorkflowHistory() {
    if (!this.workflowHistory) {
      this.productService.LoadProductWorkflowHistory(this.product.companyId!, this.product.id!)
      .then(x => {
        if (x) {
          this.workflowHistory = x;
        } else {
          this.showMessage("Failed to load workflow history!");
        }
      })
      .catch((err: any) => {
        this.showMessage("Failed to load workflow history!");
      });
    }

    return this.workflowHistory;
  }

  getTransitionTypeText(workflowHistory: ProductWorkflowHistory): string {
    if (workflowHistory.trigger) {
      return "Transitioned";
    }

    if (!workflowHistory.previousStateId) {
      return "Started";
    }

    if (workflowHistory.comments) {
      return "Comment";
    }
    
    return "Updated";
  }

  stateHasChanged(workflowHistory: ProductWorkflowHistory): boolean {
    var previousState = this.workflowHistory?.find(x => x.id == workflowHistory.previousStateId);

    return previousState?.state != workflowHistory.state;
  }

  timeAgoString(date?: Date): string {
    return Utils.timeAgoString(date);
  }

  private showMessage(message: string) {
    this.snackBar.open(message, 'OK', { duration: 2000 });
  }
}